import React, { PropTypes } from 'react';
import { Link } from 'react-router';

const ArticleLink = ({ categorySlug, slug, title }) => (
  <Link to={`/help/${categorySlug}/${slug}/`}>{ title } </Link>
);

ArticleLink.propTypes = {
  categorySlug: PropTypes.string.isRequired,

  slug: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default ArticleLink;



// WEBPACK FOOTER //
// ./help/components/article_link.jsx